import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import placed from '../../../assets/img/order-track/plc.png';
import picked from '../../../assets/img/order-track/pkd.png';
import ofd from '../../../assets/img/order-track/ofd.png';
import delivered from '../../../assets/img/order-track/del.png';

import gpay from '../../../assets/img/icon/gpay.png';
import phonepe from '../../../assets/img/icon/phonepe.png';
import debit from '../../../assets/img/icon/debitcard.png';
import credit from '../../../assets/img/icon/creditcard.png';

import design from '../../../assets/img/we-offer/necklace.jpg';

const buttons = [
    { btn1: 'Approve', btn2: 'Reject', btn3: 'Pay Now' },
];

const productdetails = [
    { metal: 'Gold' }
]



class Content extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widthControl: { width: window.innerWidth, height: document.documentElement.scrollHeight }
        };
    }

    ShowPayment = () => {
        this.setState({ payment: !this.state.payment });
    }

    ShowCarddtl = () => {
        this.setState({ carddtl: !this.state.carddtl });
    }

    render() {
        const { data, clicks } = this.state;
        return (
            <section className="team-section has-slider pt-115 pb-115">

                <div className="container">
                    <div className="section-title text-center mb-80">
                        <div className="section-title-icon">
                            <svg data-name="Layer 2" viewBox="0 0 36.11 36.11" xmlns="http://www.w3.org/2000/svg">
                                <defs>
                                    <linearGradient id="b" x1="24.54" x2="11.33" y1="33.29" y2="2.25" gradientUnits="userSpaceOnUse"><stop offset="0" stopColor="#f0862d" /><stop offset=".25" stopColor="#ef3e56" /><stop offset=".49" stopColor="#b134ec" /><stop offset=".74" stopColor="#0f66cd" /><stop offset="1" stopColor="#43c1f0" />
                                    </linearGradient>
                                    <clipPath id="a">
                                        <path fill="none" d="M3.05 26.43c2.14 3.84 5.75 6.86 10.32 8.16 4.57 1.29 9.22.62 13.06-1.53 3.84-2.14 6.86-5.75 8.16-10.32 1.29-4.57.62-9.22-1.53-13.06a17.137 17.137 0 00-10.32-8.16C18.17.23 13.52.9 9.68 3.05a17.137 17.137 0 00-8.16 10.32C.23 17.94.9 22.59 3.05 26.43m10.08 8.99c-4.8-1.36-8.59-4.53-10.84-8.57a17.99 17.99 0 01-1.6-13.72A18.02 18.02 0 019.26 2.29C13.29.04 18.19-.67 22.98.69c4.8 1.36 8.59 4.53 10.84 8.57 2.25 4.03 2.96 8.93 1.6 13.72-1.36 4.8-4.53 8.59-8.57 10.84a17.995 17.995 0 01-13.72 1.6zm11.54-10.34l-4.11 2.26 3.18.93.93-3.19zM15.55 8.76l-3.18-.93-.93 3.2c.66-.28 1.41-.76 2.07-1.13.68-.38 1.42-.74 2.04-1.14zM8.76 20.57l-.93 3.18 3.2.91c-.28-.66-.76-1.39-1.12-2.06-.36-.66-.76-1.46-1.15-2.04zm19.51-8.23l-3.19-.88c.3.66.75 1.38 1.13 2.05.36.64.76 1.48 1.17 2.04l.89-3.21zm-5.44-2.61c-.26-.74-.37-.88-.7-1.47-.26-.46-.54-1.08-.88-1.44l-1.51.76c-.39.22-1.02.48-1.36.88l4.45 1.26zm-13.1 3.56c-.38.02-2.51 1.21-2.9 1.58.13.56.47.99.76 1.51.21.37.51 1.05.88 1.36l1.26-4.45zm8.02 14.36l-4.46-1.26c.01.47 1.31 2.61 1.58 2.89.46-.1 2.54-1.26 2.87-1.63zm11.54-6.41c-.12-.47-1.17-2.46-1.63-2.87l-1.26 4.45c.47-.09 1.11-.5 1.47-.7.51-.29 1.03-.48 1.43-.89zM4.57 8.44c-.78 1.22-1.97 3.08-2.25 4.63l3.07.87-.82-5.49zm29.22 14.61l-3.07-.87.81 5.43c.76-.72 2.02-3.29 2.26-4.57zM27.62 4.63c-.77-.88-3.22-2.04-4.57-2.31l-.86 3.12 5.43-.81zM13.93 30.72c-.57-.05-4.79.6-5.43.77.06.07.01.05.19.2l.73.48c1.02.63 2.51 1.4 3.65 1.62l.86-3.08zm1.39-28.95c-1.49.06-4.19 1.15-5.09 1.74l1.54 2.42c.21.26 0 .06.32.34.41-.88 2.55-3.66 3.23-4.5zm19.02 13.55c-.33-1.69-.79-3.71-1.74-5.09-.49.19-.96.59-1.4.88l-1.3.91c.39.44 3.58 2.6 4.43 3.3zM6.21 24.1c-.66-.74-3.47-2.56-4.43-3.31.05 1.49 1.13 4.2 1.73 5.1l2.7-1.79zm19.68 8.5c-.17-.45-.56-.91-.83-1.33-.18-.28-.21-.39-.41-.66l-.36-.5c-.17-.21.07.01-.19-.21-.67.59-2.62 3.52-3.3 4.44 1.53-.06 4.16-1.13 5.09-1.74zM9.31 4.09c-.95.3-3.63 2.72-4.35 3.91l6.11-1.2-1.76-2.71zm21.81 24.06l-6.09 1.13 1.31 2.08c.33.49.08.4.63.75.66-.71 2.81-1.87 4.14-3.95zm-1.81-17.08c.62-.33 2.43-1.37 2.78-1.94-.93-.88-2.06-2.96-3.99-4.18l1.2 6.12zM6.84 25.04c-.55.29-.95.6-1.43.88-.33.19-.36.25-.64.44-.52.34-.39.03-.76.63.76.71 2.17 3.06 3.96 4.18l-1.13-6.12zm15.23-23c-1.24-.47-3.37-.6-4.73-.52-.46.02-1 0-1.4.21l5.23 3.48.91-3.17zM34.4 15.98l-3.55 5.17 3.22.92c.5-1.32.82-5.07.33-6.09zm-29.15-1l-3.21-.92c-.35.88-.47 2.31-.53 3.24-.04.6-.09 2.32.21 2.89l3.53-5.21zm15.22 19.37l-5.5-3.49-.93 3.23c1.38.55 4.1.62 5.67.47.02 0 .37-.05.37-.05.36-.09.15-.02.38-.15zM12.9 6.88c.7.28 1.66.5 2.41.71 1.03.29 1.36.6 2.06.18 1.03-.61 2.04-1.12 3.05-1.74l-4.7-3-2.81 3.85zm12.87 3.68c.8.22 1.59.44 2.38.68.06-.46-.42-2.23-.53-2.79l-.53-2.39c-.05-.15-.06-.17-.1-.27-.79.04-1.64.24-2.42.34-.42.05-.77.13-1.19.18-.19.02-.38.03-.56.07l-.51.17c.58 1.04 1.13 1.97 1.69 3.03.43.81.63.66 1.76.97zM6.04 15.71L3 20.4l3.86 2.84c.29-.7.49-1.6.69-2.31.3-1.04.63-1.46.21-2.17-.59-.99-1.11-2.13-1.72-3.04zM30.31 27l-.66-4.66c-.56.11-2.39 1.28-3.05 1.63-.88.47-.67.44-1.02 1.69-.23.83-.47 1.68-.71 2.51.47.03 3.79-.74 4.73-.95l.72-.21zm2.8-11.28l-3.86-2.85c-.29.72-.49 1.59-.7 2.32-.29 1.03-.63 1.46-.21 2.18.59 1.01 1.11 2.11 1.73 3.03l3.05-4.68zm-21.88-7.8c-.77.06-1.82.35-2.68.55-.88.2-1.96.32-2.75.65l.67 4.66c.57-.11 2.44-1.32 3.12-1.67.81-.42.65-.62.97-1.76.22-.76.52-1.66.67-2.42zm11.99 21.31c-.67-.27-1.58-.47-2.29-.68-1.04-.3-1.46-.63-2.17-.21-1.03.6-2.06 1.11-3.05 1.72l4.69 3.04c.44-.37 2.59-3.35 2.83-3.88zm-9.44.41l-1.84-3.42c-.32-.46-3.31-1.16-4.03-1.35-.03.74.34 1.94.48 2.75.07.45.15.87.25 1.34.08.4.14 1.02.34 1.39l4.8-.7zm13.15-12.5c.06-.42-2.37-4.5-2.74-5.18-.68-1.26-.64-.96-3.05-1.64-.93-.26-3.18-1.03-3.98-1.12-.54-.06-4.66 2.43-5.2 2.73-1.27.71-.93.53-1.64 3.05-1.47 5.19-1.89 2.96 1.6 9.18.31.55.26.85 1.04 1.08l6 1.68c.46.05.95-.36 1.34-.58l3.85-2.15c.53-.29.85-.27 1.08-1.04l1.7-6.01z" clipRule="evenodd" />
                                    </clipPath>
                                </defs><g clipPath="url(#a)" data-name="Layer 1"><path fill="url(#b)" d="M-.67-.67h37.45v37.45H-.67z" /></g>
                            </svg>
                        </div>
                        <span className="title-tag">CAD Design of your Customized Jewel is here.</span>
                        {/* <h6>You can Approve or Reject the Design</h6>
                        <div className="text-center">
                            <embed src='https://www.clickdimensions.com/links/TestPDFfile.pdf' type="application/pdf"
                                frameBorder="0"
                                scrolling="auto"
                                height="500px"
                                width="100%">
                            </embed>
                        </div> */}
                    </div>
                    <div className='track d-blok mt-5'>
                        <div className='col-12 mb-5 mt-5'>
                            <div className="box-header mt-5">
                                <div className="">
                                    <h5>Order Tracking</h5>
                                </div>
                                <div className="order-id">#SPK1218153635</div>
                            </div>

                            <div className='track-dtl mt-5'>
                                <div className='d-flex justify-content-center'>
                                    <div className='order-placed'>
                                        <div className='plc'>
                                            <div ClassName="plc-img">
                                                <span ClassName="" id='png'>
                                                    <img src={placed} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order Placed</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='plc-dsc'>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-picked'>
                                        <div className='pkd'>
                                            <div ClassName="plc-img">
                                                <span ClassName="" id='png'>
                                                    <img src={picked} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="pkd-txt">
                                                <p ClassName="">Order Picked</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='pkd-dsc'>
                                            <div ClassName="pkd-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-ofd'>
                                        <div className='ofd'>
                                            <div ClassName="ofd-img mr-5">
                                                <span ClassName="" id='png'>
                                                    <img src={ofd} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="ofd-txt">
                                                <p ClassName="">Out for Delivery</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='ofd-dsc'>
                                            <div ClassName="ofd-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-del'>
                                        <div className='del'>
                                            <div ClassName="del-img">
                                                <span ClassName="" id='png'>
                                                    <img src={delivered} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="del-txt">
                                                <p ClassName="">Delivered</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='del-dsc'>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className='track mt-5'>
                        <div className='col-12 mb-5 mt-5 d-flex flex-column'>
                            <div className="box-header mt-5">
                                <div className="">
                                    <h5>Order Tracking</h5>
                                </div>
                                <div className="order-id">#SPK1218153635</div>
                            </div>

                            <div className='track-dtl d-none d-md-block mt-5'>
                                <div className='d-flex flex-column float-left'>
                                    <div className='order-placed'>
                                        <div className='splc d-flex'>
                                            <div ClassName="plc-img">
                                                <span ClassName="" id='png'>
                                                    <img src={placed} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order Placed</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='plc-dsc ml-5'>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-picked'>
                                        <div className='spkd d-flex'>
                                            <div ClassName="plc-img">
                                                <span ClassName="" id='png'>
                                                    <img src={picked} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="pkd-txt">
                                                <p ClassName="">Order Picked</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='pkd-dsc ml-5'>
                                            <div ClassName="pkd-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-ofd'>
                                        <div className='sofd d-flex'>
                                            <div ClassName="ofd-img mr-5">
                                                <span ClassName="" id='png'>
                                                    <img src={ofd} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="ofd-txt">
                                                <p ClassName="">Out for Delivery</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='ofd-dsc ml-5'>
                                            <div ClassName="ofd-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='order-del'>
                                        <div className='del d-flex'>
                                            <div ClassName="del-img">
                                                <span ClassName="" id='png'>
                                                    <img src={delivered} alt="" />
                                                </span>
                                            </div>
                                            <div ClassName="del-txt">
                                                <p ClassName="">Delivered</p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                        <div className='del-dsc ml-5'>
                                            <div ClassName="plc-txt">
                                                <p ClassName="">Order placed successfully by <a href="javascript:void(0);"
                                                    ClassName="font-weight-semibold text-primary">Sansa Taylor</a></p>
                                                <span ClassName="">Nov 03, 2022</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className='row mb-5 mt-5'>
                        <div className='col-5'>
                            <img src={design} />
                        </div>
                        <div className="col-7 detail-table">
                            <table className="table cw-cart-table">
                                <tbody>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Metal</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">Gold</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Category</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">Chain</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Metal Weight</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">3 g</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Metal Quality</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">22 kt</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Color</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">Yellow Gold</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Diamond Quality</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">VVS-EF</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Diamond Weight</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">2 g</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Stone</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">Emerald</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Stone Weight</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">3 g</td>
                                    </tr>
                                    <tr>
                                        <td className="product-price text-white cw-align has-title" data-title="Order ID"><h6>Total Amount</h6></td>
                                        <td className="product-price text-white cw-align has-title" data-title="Order Date">₹ 50,000</td>
                                    </tr>
                                    {/* <a href='#' onClick={this.ShowPayment}>Select Payment Method</a> */}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {buttons.map((item) => (
                        <div className="text-center d-flex justify-content-center">
                            <ul className='d-flex justify-content-center'>
                                <li className='mr-3' data-animation="fadeInUp" data-delay="1.1s" onClick={this.ShowPayment}>
                                    <button className="main-btn btn-filled">{item.btn1}</button>
                                </li>
                                <li data-animation="fadeInUp" data-delay="1.3s">
                                    <Link className="main-btn btn-border" to="">{item.btn2}</Link>
                                </li>
                            </ul>
                        </div>
                    ))}

                    {this.state.payment &&
                        <div className='mt-5 d-flex flex-column align-center text-center'>
                            <span className="title-tag mb-3" >We request you to Pay 30% amount initially</span>
                            <h5>Select a Payment Method</h5>
                            <div class="check input-group mt-5 row">
                                <div className='col-3'>
                                    <div class="pay checkout-term align-items-center">
                                        <input class="radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1" style={{ width: "15px" }} />
                                        <label class="check-label input-group-two ml-2 mt-2" for="flexRadioDefault1">
                                            <img className='mr-2' src={gpay} />
                                            G-Pay</label>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div class="pay checkout-term align-items-center">
                                        <input class="radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1" style={{ width: "15px" }} />
                                        <label class="check-label input-group-two ml-2 mt-2" for="flexRadioDefault1"><img className='mr-2' src={phonepe} />Phonepe</label>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div class="pay checkout-term align-items-center">
                                        <input class="radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1" style={{ width: "15px" }} onChange={this.ShowCarddtl} />
                                        <label class="check-label input-group-two ml-2 mt-2" for="flexRadioDefault1"><img className='mr-2' src={debit} />Debit Card</label>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <div class="pay checkout-term align-items-center">
                                        <input class="radio" type="radio" name="flexRadioDefault" id="flexRadioDefault1" style={{ width: "15px" }} onChange={this.ShowCarddtl} />
                                        <label class="check-label input-group-two ml-2 mt-2" for="flexRadioDefault1"><img className='mr-2' src={credit} />Credit Card</label>
                                    </div>
                                </div>
                            </div>
                            {this.state.carddtl &&
                                <div className='row mt-5'>
                                    <div className="col-6 input-group input-group-two mb-20">
                                        <label>Card Holder Name
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input type="number" placeholder="Name" name="customer_street" />
                                    </div>
                                    <div className="col-6 input-group input-group-two mb-20">
                                        <label>Card Number
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input type="number" placeholder="Number" name="customer_street" />
                                    </div>
                                    <div className="col-6 input-group input-group-two mb-20">
                                        <label>Valid Thru
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input type="text" placeholder="Name" name="customer_street" />
                                    </div>
                                    <div className="col-6 input-group input-group-two mb-20">
                                        <label>CVV
                                            <span className="text-danger">*</span>
                                        </label>
                                        <input type="number" placeholder="Enter CVV" name="customer_street" />
                                    </div>
                                </div>
                            }

                            {buttons.map((item) => (
                                <div className="text-center d-flex justify-content-center mt-5">
                                    <ul className='d-flex justify-content-center'>
                                        <li className='mr-3' data-animation="fadeInUp" data-delay="1.1s" onClick={this.ShowPayment}>
                                            <button className="main-btn btn-filled">{item.btn3}</button>
                                        </li>
                                        {/* <li data-animation="fadeInUp" data-delay="1.3s">
                                            <Link className="main-btn btn-border" to="/about">{item.btn2}</Link>
                                        </li> */}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    }
                </div>

            </section>
        );
    }
}

export default Content;